import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { PermissionService } from '../permission.service';

/**
 * Route guard that checks user permissions.
 *
 * Usage in route config:
 *   {
 *     path: 'warehouses',
 *     canActivate: [permissionGuard],
 *     data: { permissions: [Permissions.WarehouseListView] },
 *     ...
 *   }
 *
 * Multiple permissions = user needs at least one (OR logic).
 */
export const permissionGuard: CanActivateFn = (route) => {
    const permissionService = inject(PermissionService);
    const router = inject(Router);

    const requiredPermissions: string[] = route.data?.['permissions'] ?? [];

    if (requiredPermissions.length === 0) {
        return true;
    }

    const hasAccess = permissionService.hasAnyPermission(...requiredPermissions);
    return hasAccess || router.createUrlTree(['/unauthorized']);
};
